import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  buttonRow: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
  },
  button: {
    height: theme.spacing(5),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.header.main,
  },
}));

const ButtonHeader = ({ title, subTitle, buttonList, ...props }) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'space-between' }}>
      {subTitle ? (
        <>
          <Grid item sm={3}>
            <Typography variant="h5">{title}</Typography>
          </Grid>
          <Grid item sm={9} style={{ marginTop: '10px' }}>
            <Typography>{subTitle}</Typography>
          </Grid>
        </>
      ) : (
        <Typography variant="h5">{title}</Typography>
      )}
      {buttonList && (
        <>
          <Grid containter spacing={2} style={{ display: 'flex' }}>
            {buttonList &&
              buttonList.map((button) => (
                <Grid item style={{ paddingInline: '1vw' }}>
                  <Button
                    className={classes.button}
                    variant="contained"
                    onClick={button.action}
                    key={button.name}
                    startIcon={button.icon}
                  >
                    {button.name}
                  </Button>
                </Grid>
              ))}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ButtonHeader;
